export class CardFormatterService {
    public static addSpaces(value: string, format: number[]): string {
        if (!value) {
            return '';
        }

        if (format.length === 0) {
            return value;
        }

        const cardNumber = value.replace(/\s*/g, '');
        let formatted = cardNumber.substr(0, format[0]);
        let lastIndex = format[0];

        for (let i = 1; i < format.length; i++) {
            formatted += ` ${cardNumber.substr(lastIndex, format[i])}`;
            lastIndex += format[i];
        }
        return formatted;
    }

    public static getLast4Digits(value: string) {
        const formatted = CardFormatterService.addSpaces(value, [4, 4, 4, 4]);
        return formatted.slice(-4);
    }
}
